/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { interactionDetailResponseDtoSchema } from "../interactionDetailResponseDtoSchema";
import { z } from "zod/v4";

export const getInteractionPathParamsSchema = z.object({
    "interactionId": z.uuid().describe("Interaction primary key (`interactions.id`).")
    })

export const getInteractionHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

/**
 * @description Interaction found
 */
export const getInteraction200Schema = z.lazy(() => interactionDetailResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const getInteraction401Schema = z.any()

/**
 * @description No interaction with this id exists.
 */
export const getInteraction404Schema = z.any()

export const getInteractionQueryResponseSchema = z.lazy(() => getInteraction200Schema)